import * as moment from 'moment';

export class TimeSlot {
	public id;
	public name;
	public start_time;
	public end_time;
	public is_part_of_working_day;
	
	constructor(obj) {
		this.id = obj.id;
		this.name = obj.name;
		this.start_time = obj.start_time;
		this.end_time = obj.end_time;
		this.is_part_of_working_day = obj.is_part_of_working_day;
	}

	nameWithTime() {
	    return this.name + " (" + moment(this.start_time).format("HH:mm") + " - " + moment(this.end_time).format("HH:mm") + ")";
	};
} 
